import { atom } from "recoil";
export const seasonAtoms = atom({
  key: "seasonAtoms", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
